import { RefObject, useRef } from 'react';

export function useDraggableScroll(
  ref: RefObject<HTMLElement | null | undefined>,
  options: {
    direction?: 'vertical' | 'horizontal' | 'both';
  } = { direction: 'both' }
) {
  const { direction } = options;
  const initialPosition = useRef({
    scrollTop: 0,
    scrollLeft: 0,
    mouseX: 0,
    mouseY: 0,
  });

  const mouseMoveHandler = (event: { clientX: number; clientY: number }) => {
    if (ref.current) {
      const dx = event.clientX - initialPosition.current.mouseX;
      const dy = event.clientY - initialPosition.current.mouseY;

      if (direction !== 'horizontal') {
        ref.current.scrollTop = initialPosition.current.scrollTop - dy;
      }
      if (direction !== 'vertical') {
        ref.current.scrollLeft = initialPosition.current.scrollLeft - dx;
      }
    }
  };

  const mouseUpHandler = () => {
    document.removeEventListener('mousemove', mouseMoveHandler);
    document.removeEventListener('mouseup', mouseUpHandler);
  };

  const onMouseDown = (event: { clientX: number; clientY: number }) => {
    if (ref.current) {
      initialPosition.current = {
        scrollLeft: ref.current.scrollLeft,
        scrollTop: ref.current.scrollTop,
        mouseX: event.clientX,
        mouseY: event.clientY,
      };

      ref.current.style.userSelect = 'none';

      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    }
  };

  return { onMouseDown };
}
